import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faDownload } from "@fortawesome/free-solid-svg-icons";
import Switch from "../../components/Switch/Switch";
import Button from "../../components/Button/Button";
import "./ReportCard.css";

export const reportCardTableConstants = (
  selectStudentHandler,
  selectedStudentIds,
  previewResult,
  downloadResult,
  term,
  studentList,
  downloadAllResult,
  downloadExcelResult
) => {
  return [
    {
      title: "Sr. No",
      render: (rowData, index) => (
        <span className="rc-serial-no">{index + 1}</span>
      ),
    },
    {
      title: "Roll No",
      key: "roll_no",
      render: (rowData) => <span>{rowData.roll_no}</span>,
    },
    {
      title: "Admission No",
      key: "id_number",
      render: (rowData) => <span>{rowData.id_number}</span>,
    },
    {
      title: "Student Name",
      key: "first_name",
      render: (rowData) => (
        <span>{`${rowData.first_name} ${rowData.last_name}`}</span>
      ),
    },
    {
      title: "Class",
      render: (rowData) => (
        <span>{rowData.programs && rowData.programs.name}</span>
      ),
    },
    {
      title: "Preview",
      render: (rowData) => (
        <span
          className="rc-icon-preview"
          onClick={() => previewResult(rowData, term)}
          title="Preview report card"
        >
          <FontAwesomeIcon icon={faEye} />
        </span>
      ),
    },
    {
      title: () => (
        <div className="rc-select-all-header">
          <label className="rc-select-all-label">Select All:</label>
          <Switch
            name={"select_all"}
            id={"select_all"}
            checked={selectedStudentIds.length === studentList.length && studentList.length > 0}
            onChange={(e) => {
              selectStudentHandler({
                target: { checked: e.target.checked, value: "all" },
              });
            }}
          />
        </div>
      ),
      render: (rowData) => (
        <div className="rc-select-cell">
          <Switch
            name="student"
            id={rowData.id}
            value={rowData.id}
            checked={selectedStudentIds.includes(rowData.id.toString())}
            onChange={(e) => selectStudentHandler(e)}
            title={
              selectedStudentIds.includes(rowData.id.toString())
                ? "Deselect"
                : "Select"
            }
          />
        </div>
      ),
    },
    {
      title: () => (
        <div className="rc-download-header">
          <Button
            className="btn-sm"
            size="sm"
            onClick={() => downloadAllResult(studentList, term)}
            title="Download all selected report cards as PDF"
          >
            📥 PDF
          </Button>
          <Button
            className="btn-sm"
            size="sm"
            onClick={() => downloadExcelResult(term)}
            title="Download all results as Excel"
          >
            📊 Excel
          </Button>
        </div>
      ),
      render: (rowData) => (
        <span
          className="rc-icon-download"
          onClick={() => downloadResult(rowData, term)}
          title="Download individual report card"
        >
          <FontAwesomeIcon icon={faDownload} />
          <span className="rc-icon-download-label">Download</span>
        </span>
      ),
    },
  ];
};

